// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_label__uzp-6 {
  margin: 0 0 5px 5px;
}

.styles_status__0J83h {
  margin-top: 23px;
}

.styles_rowControl__hfw5W {
  padding: 10px 0px 0px 0px;
}

.styles_clearButton__1LXgZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_clearButton__1LXgZ:hover {
  background: #f44336;
  color: white;
}

.styles_containerFilter__qJh2Y {
  background-color: white;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 1px -1px rgba(164, 166, 163, 0.9803921569);
  border-radius: 5px;
}
.styles_containerFilter__qJh2Y h3 {
  font-size: 16px;
}

.styles_addButtonCol__AF9fZ {
  display: flex;
  align-items: center;
}

.styles_clearButtonCol__kOWrQ {
  display: flex;
  align-items: center;
}

.styles_loading__l2rOQ {
  display: flex;
  align-items: center;
}

.styles_spaceBetween__pB4jh {
  display: flex;
  justify-content: space-between;
}

.styles_btnGenerator__wBkzn {
  text-decoration: underline;
  cursor: pointer;
}

.styles_inputGenerator__fC6on {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(227, 226, 226);
  border-radius: 4px;
  height: 40px;
  padding-left: 5px;
}
.styles_inputGenerator__fC6on span {
  padding-top: 2px;
  margin-left: 4px;
}

.styles_inputGeneratorDisable__-oq5D {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(227, 226, 226);
  border-radius: 4px;
  height: 40px;
  padding-left: 5px;
}
.styles_inputGeneratorDisable__-oq5D span {
  padding-top: 2px;
  margin-left: 4px;
}
.styles_inputGeneratorDisable__-oq5D {
  background-color: #eff2f5;
}

.styles_inputGeneratorNone__EzaP9 {
  border: none !important;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Financeiro/TrancacaoFinanceira/FormTransacao/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAAF;AAEE;EACE,gBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AADF;AAGE;EACE,gBAAA;EACA,gBAAA;AADJ;AAVA;EAcE,yBAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;AADF","sourcesContent":[".label {\n  margin: 0 0 5px 5px;\n}\n\n.status {\n  margin-top: 23px;\n}\n\n.rowControl {\n  padding: 10px 0px 0px 0px;\n}\n\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.clearButton:hover {\n  background: #f44336;\n  color: white;\n}\n\n.containerFilter {\n  background-color: white;\n  padding: 12px;\n  margin-bottom: 10px;\n  box-shadow: 1px 1px 1px -1px #a4a6a3fa;\n  border-radius: 5px;\n\n  h3 {\n    font-size: 16px;\n  }\n}\n\n.addButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.clearButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n}\n\n.spaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n\n.btnGenerator {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.inputGenerator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgb(227, 226, 226);\n  border-radius: 4px;\n  height: 40px;\n  padding-left: 5px;\n\n  span {\n    padding-top: 2px;\n    margin-left: 4px;\n  }\n}\n\n.inputGeneratorDisable {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgb(227, 226, 226);\n  border-radius: 4px;\n  height: 40px;\n  padding-left: 5px;\n\n  span {\n    padding-top: 2px;\n    margin-left: 4px;\n  }\n\n  background-color: #eff2f5;\n}\n\n.inputGeneratorNone {\n  border: none !important;\n  height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `styles_label__uzp-6`,
	"status": `styles_status__0J83h`,
	"rowControl": `styles_rowControl__hfw5W`,
	"clearButton": `styles_clearButton__1LXgZ`,
	"containerFilter": `styles_containerFilter__qJh2Y`,
	"addButtonCol": `styles_addButtonCol__AF9fZ`,
	"clearButtonCol": `styles_clearButtonCol__kOWrQ`,
	"loading": `styles_loading__l2rOQ`,
	"spaceBetween": `styles_spaceBetween__pB4jh`,
	"btnGenerator": `styles_btnGenerator__wBkzn`,
	"inputGenerator": `styles_inputGenerator__fC6on`,
	"inputGeneratorDisable": `styles_inputGeneratorDisable__-oq5D`,
	"inputGeneratorNone": `styles_inputGeneratorNone__EzaP9`
};
export default ___CSS_LOADER_EXPORT___;
